export default __webpack_public_path__ + "static/media/_mars.01c44c7d.ico";